

















































































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { InstitutionAccountSettingsModule } from '@/store/Accounts/InstitutionAccountSettingsModule';
import UpdateInstitutionAccountSettingsRequest from '@/models/Accounts/InstitutionAccounts/Settings/UpdateInstitutionAccountSettingsRequest';
import Amount from '@/models/Shared/Amount';

@Component({ name: 'InstitutionAccountSettingsEdit' })
export default class extends SaascadaVueDialog {

    transactionLimitAsNumber: number = 0;
    dailyLimitAsNumber: number = 0;
    oneApprovalThresholdActive: boolean = false;
    oneApprovalThresholdAsNumber: number =0;
    twoApprovalThresholdActive: boolean = false;
    twoApprovalThresholdAsNumber: number =0;
    threeApprovalThresholdActive: boolean = false;
    threeApprovalThresholdAsNumber: number =0;

    @Watch('dialog')
    onDialogChanged(val: boolean, oldVal: boolean) {
        if (val) {
            this.transactionLimitAsNumber = +InstitutionAccountSettingsModule.institutionalAccountSettings.transactionLimit.amount;
            this.dailyLimitAsNumber = +InstitutionAccountSettingsModule.institutionalAccountSettings.dailyLimit.amount;
            this.oneApprovalThresholdActive = InstitutionAccountSettingsModule.institutionalAccountSettings.oneApprovalThresholdActive;
            this.oneApprovalThresholdAsNumber = +InstitutionAccountSettingsModule.institutionalAccountSettings.oneApprovalThreshold.amount;
            this.twoApprovalThresholdActive = InstitutionAccountSettingsModule.institutionalAccountSettings.twoApprovalThresholdActive;
            this.twoApprovalThresholdAsNumber = +InstitutionAccountSettingsModule.institutionalAccountSettings.twoApprovalThreshold.amount;
            this.threeApprovalThresholdActive = InstitutionAccountSettingsModule.institutionalAccountSettings.threeApprovalThresholdActive;
            this.threeApprovalThresholdAsNumber = +InstitutionAccountSettingsModule.institutionalAccountSettings.threeApprovalThreshold.amount;
        }
    }

    get currencySymbol() {
        return InstitutionAccountSettingsModule.institutionalAccountSettings.currency;
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            const accountCurrency = InstitutionAccountSettingsModule.institutionalAccountSettings.currency;
            const request = new UpdateInstitutionAccountSettingsRequest()
            const dailyLimitAmount = new Amount();
            dailyLimitAmount.currency = accountCurrency;
            dailyLimitAmount.amount = String(this.dailyLimitAsNumber);
            request.dailyLimit = dailyLimitAmount;

            const transactionLimitAmount = new Amount();
            transactionLimitAmount.currency = accountCurrency;
            transactionLimitAmount.amount = String(this.transactionLimitAsNumber);
            request.transactionLimit = transactionLimitAmount;

            const oneApprovalThresholdAmount = new Amount();
            oneApprovalThresholdAmount.currency = accountCurrency;

            if (this.oneApprovalThresholdActive) {
                oneApprovalThresholdAmount.amount = String(this.oneApprovalThresholdAsNumber);
            }
            else {
                oneApprovalThresholdAmount.amount = "0";
            }

            request.oneApprovalThreshold = oneApprovalThresholdAmount;
            request.oneApprovalThresholdActive = this.oneApprovalThresholdActive;

            const twoApprovalThresholdAmount = new Amount();
            twoApprovalThresholdAmount.currency = accountCurrency;

            if (this.twoApprovalThresholdActive) {
                twoApprovalThresholdAmount.amount = String(this.twoApprovalThresholdAsNumber);
            }
            else {
                twoApprovalThresholdAmount.amount = "0";
            }

            request.twoApprovalThreshold = twoApprovalThresholdAmount;
            request.twoApprovalThresholdActive = this.twoApprovalThresholdActive;

            const threeApprovalThresholdAmount = new Amount();
            threeApprovalThresholdAmount.currency = accountCurrency;

            if (this.threeApprovalThresholdActive) {
                threeApprovalThresholdAmount.amount = String(this.threeApprovalThresholdAsNumber);
            }
            else {
                threeApprovalThresholdAmount.amount = "0";
            }

            request.threeApprovalThreshold = threeApprovalThresholdAmount;
            request.threeApprovalThresholdActive = this.threeApprovalThresholdActive;

            await InstitutionAccountSettingsModule.editInstitutionalAccountSettings(request);
        }
    }

}
